/* Vogue Avenue — storefront behaviour (hero playlist, countdown, delivery ETA, size assistant, cart tiers) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Hero video playlist ---------- */
  function initHero() {
    $$('[data-va-hero]').forEach(function (hero) {
      var dots = $$('.va-hero__dots span', hero);
      $$('[data-va-playlist]', hero).forEach(function (list) {
        var vids = $$('video', list);
        if (!vids.length) return;
        var i = 0;
        function play(n) {
          vids.forEach(function (v, k) { if (k !== n) { v.classList.remove('is-active'); } });
          var v = vids[n];
          if (!v.getAttribute('src')) { v.setAttribute('src', v.dataset.src); }
          v.currentTime = 0;
          var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
          v.classList.add('is-active');
          if (list.offsetParent !== null) { dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); }); }
          var next = vids[(n + 1) % vids.length];
          if (next && !next.getAttribute('src')) { next.setAttribute('preload', 'auto'); next.setAttribute('src', next.dataset.src); }
        }
        vids.forEach(function (v, k) {
          v.addEventListener('ended', function () { i = (k + 1) % vids.length; play(i); });
        });
        if (vids.length === 1) { vids[0].loop = true; }
        if (list.offsetParent !== null) { play(0); }
      });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    $$('[data-va-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.vaCountdown + 'T23:59:59').getTime();
      if (isNaN(end)) { el.style.display = 'none'; return; }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var d = Math.max(0, end - Date.now());
        if (d <= 0) { el.style.display = 'none'; return; }
        $('[data-d]', el).textContent = pad(Math.floor(d / 864e5));
        $('[data-h]', el).textContent = pad(Math.floor(d / 36e5) % 24);
        $('[data-m]', el).textContent = pad(Math.floor(d / 6e4) % 60);
        $('[data-s]', el).textContent = pad(Math.floor(d / 1e3) % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Delivery estimate (2–4 processing + 3–4 transit = 5–8 business days) ---------- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) { n--; } }
    return d;
  }
  function initEta() {
    var els = $$('[data-va-eta]');
    if (!els.length) return;
    var opts = { weekday: 'short', month: 'short', day: 'numeric' };
    var a = addBusinessDays(new Date(), 5).toLocaleDateString('en-US', opts);
    var b = addBusinessDays(new Date(), 8).toLocaleDateString('en-US', opts);
    els.forEach(function (el) { el.innerHTML = 'Order today, arrives <b>' + a + ' – ' + b + '</b>'; });
  }

  /* ---------- Sample reviews guard (never show sample content on the live theme) ---------- */
  function guardSamples() {
    try {
      if (window.Shopify && Shopify.theme && Shopify.theme.role === 'main' && !(Shopify.designMode)) {
        $$('[data-va-sample]').forEach(function (el) { el.remove(); });
      }
    } catch (e) {}
  }

  /* ---------- Size assistant ---------- */
  var LETTERS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  function letterOf(v) {
    var s = String(v).toUpperCase().replace(/\s+/g, ' ');
    var m = s.match(/(^|[^A-Z0-9])(XXXXL|XXXL|XXL|6XL|5XL|4XL|3XL|2XL|XXS|XS|XL|S|M|L)(?![A-Z])/);
    if (!m) return null;
    var t = m[2];
    if (t === 'XXL') t = '2XL';
    if (t === 'XXXL') t = '3XL';
    if (t === 'XXXXL') t = '4XL';
    return t;
  }
  function numericToLetter(n, gender) {
    if (gender === 'men') {
      if (n >= 28 && n <= 50) { return n <= 30 ? 'S' : n <= 32 ? 'M' : n <= 34 ? 'L' : n <= 36 ? 'XL' : n <= 38 ? '2XL' : '3XL'; }
      return null;
    }
    if (n >= 32 && n <= 54) { return n <= 34 ? 'XS' : n <= 36 ? 'S' : n <= 40 ? 'M' : n <= 42 ? 'L' : n <= 44 ? 'XL' : n <= 46 ? '2XL' : '3XL'; }
    if (n >= 0 && n <= 30) { return n <= 2 ? 'XS' : n <= 6 ? 'S' : n <= 10 ? 'M' : n <= 14 ? 'L' : n <= 16 ? 'XL' : n <= 20 ? '2XL' : '3XL'; }
    return null;
  }

  function initSizeAssistant() {
    var modal = $('#VaSizeModal');
    if (!modal) return;
    var gender = modal.dataset.gender, family = modal.dataset.family;
    var optIndex = parseInt(modal.dataset.optionIndex, 10);
    var sizes = [];
    try { sizes = JSON.parse(modal.dataset.sizes); } catch (e) {}
    var steps = $$('.va-step', modal), bars = $$('.va-steps i', modal);
    var cur = 0, unit = 'imperial', shoeSys = 'us', result = null;
    var btnNext = $('[data-va-next]', modal), btnBack = $('[data-va-back]', modal), nav = $('[data-va-nav]', modal);

    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; go(0); }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-va-size-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-va-close]')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function go(n) {
      cur = n;
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      bars.forEach(function (b, k) { b.classList.toggle('is-on', k <= n); });
      btnBack.hidden = n === 0;
      nav.style.display = n === steps.length - 1 ? 'none' : '';
      btnNext.textContent = n === steps.length - 2 ? 'Show my size' : 'Continue';
    }
    btnBack.addEventListener('click', function () { if (cur > 0) go(cur - 1); });
    btnNext.addEventListener('click', function () {
      if (cur === 0 && !validFirst()) return;
      if (cur === steps.length - 2) { compute(); }
      go(Math.min(cur + 1, steps.length - 1));
    });

    $$('[data-choice]', modal).forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.va-opt'); if (!b) return;
        $$('.va-opt', g).forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on');
      });
    });
    function choice(name) { var b = $('[data-choice="' + name + '"] .is-on', modal); return b ? parseFloat(b.dataset.val) : 0; }

    // unit toggles
    $$('[data-unit-group]', modal).forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        $$('button', g).forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on');
        if (g.dataset.unitGroup === 'metric') {
          unit = b.dataset.unit;
          $$('[data-units]', modal).forEach(function (f) { f.hidden = f.dataset.units !== unit; });
        } else { shoeSys = b.dataset.unit; fillShoes(); }
      });
    });

    function fillShoes() {
      var sel = $('[data-va-shoe]', modal); if (!sel) return;
      var r = { us: gender === 'men' ? [6, 15] : [4, 12], eu: gender === 'men' ? [38, 49] : [34, 44], uk: gender === 'men' ? [5, 14] : [2, 10] }[shoeSys];
      var def = { us: gender === 'men' ? 10 : 8, eu: gender === 'men' ? 43 : 39, uk: gender === 'men' ? 9 : 6 }[shoeSys];
      var html = '';
      for (var v = r[0]; v <= r[1]; v += (shoeSys === 'eu' ? 1 : 0.5)) { html += '<option value="' + v + '"' + (v === def ? ' selected' : '') + '>' + shoeSys.toUpperCase() + ' ' + v + '</option>'; }
      sel.innerHTML = html;
    }
    fillShoes();

    function validFirst() {
      if (family === 'shoes') return true;
      var ok = unit === 'imperial' ? parseFloat($('[data-va-lbs]', modal).value) > 0 : (parseFloat($('[data-va-cm]', modal).value) > 0 && parseFloat($('[data-va-kg]', modal).value) > 0);
      if (!ok) { var f = $(unit === 'imperial' ? '[data-va-lbs]' : '[data-va-cm]', modal); f.focus(); f.style.borderColor = '#A9472A'; }
      return ok;
    }

    function pickFromProduct(targetLetter) {
      // map product option values -> letter index, choose closest
      var t = LETTERS.indexOf(targetLetter), best = null, bestD = 99;
      sizes.forEach(function (v) {
        var l = letterOf(v);
        if (!l) { var n = parseFloat(String(v).replace(',', '.')); if (!isNaN(n)) l = numericToLetter(n, gender); }
        if (!l) return;
        var d = Math.abs(LETTERS.indexOf(l) - t) + (LETTERS.indexOf(l) < t ? 0.1 : 0);
        if (d < bestD) { bestD = d; best = v; }
      });
      return best;
    }

    function compute() {
      var tags = [], explain = '';
      if (family === 'shoes') {
        var v = parseFloat($('[data-va-shoe]', modal).value);
        // convert user's size to EU
        var eu = shoeSys === 'eu' ? v : shoeSys === 'us' ? (gender === 'men' ? v + 33 : v + 30.5) : (gender === 'men' ? v + 34 : v + 32.5);
        eu += choice('width') * 2 * 0.5 + choice('socks') * 2 * 0.5;
        var nums = sizes.map(function (s) { return parseFloat(String(s).replace(',', '.')); }).filter(function (n) { return !isNaN(n); });
        var prodEU = nums.length && Math.max.apply(null, nums) >= 30;
        var target = prodEU ? eu : (gender === 'men' ? eu - 33 : eu - 30.5);
        var best = null, bestD = 99;
        sizes.forEach(function (s) {
          var n = parseFloat(String(s).replace(',', '.')); if (isNaN(n)) return;
          var d = Math.abs(n - target) + (n < target - 0.01 ? 0.3 : 0); // prefer rounding up
          if (d < bestD) { bestD = d; best = s; }
        });
        result = best;
        tags.push(choice('width') > 0 ? 'Wide feet' : choice('width') < 0 ? 'Narrow feet' : 'Regular width');
        if (choice('socks') >= 0.5) tags.push('Room for thick socks');
        explain = best ? 'Between two sizes? We rounded up for comfort, especially with socks.' : 'We could not match this model automatically — our team will help by email.';
      } else {
        var cm, kg;
        if (unit === 'imperial') {
          cm = (parseFloat($('[data-va-ft]', modal).value) * 12 + parseFloat($('[data-va-in]', modal).value)) * 2.54;
          kg = parseFloat($('[data-va-lbs]', modal).value) * 0.4536;
        } else { cm = parseFloat($('[data-va-cm]', modal).value); kg = parseFloat($('[data-va-kg]', modal).value); }
        var bmi = kg / Math.pow(cm / 100, 2), idx;
        if (gender === 'men') {
          idx = bmi < 21 ? 2 : bmi < 24.5 ? 3 : bmi < 28 ? 4 : bmi < 31.5 ? 5 : bmi < 35 ? 6 : bmi < 39 ? 7 : 8;
          if (cm > 188) idx += 0.5; if (cm < 168) idx -= 0.5;
        } else {
          idx = bmi < 19 ? 1 : bmi < 22 ? 2 : bmi < 25.5 ? 3 : bmi < 29 ? 4 : bmi < 33 ? 5 : bmi < 37 ? 6 : bmi < 41 ? 7 : 8;
          if (cm > 178) idx += 0.5; if (cm < 155) idx -= 0.4;
        }
        var build = choice('build'), fit = choice('fit'), layer = choice('layer');
        var wBuild = family === 'bottoms' ? 0.7 : family === 'dresses' ? 0.7 : 0.55;
        idx += build * wBuild + fit * 0.5;
        if (family === 'outerwear') idx += layer * 0.6;
        idx = Math.max(0, Math.min(LETTERS.length - 1, Math.round(idx)));
        var letter = LETTERS[idx];
        result = pickFromProduct(letter) || null;
        tags.push(fit > 0 ? 'Relaxed fit' : fit < 0 ? 'Close fit' : 'True-to-size fit');
        if (family === 'outerwear' && layer > 0) tags.push('Room for layering');
        if (build !== 0) tags.push(build > 0 ? (gender === 'men' ? 'Broad build' : 'Curvy figure') : 'Slim build');
        explain = 'Based on ' + Math.round(cm) + ' cm / ' + Math.round(kg) + ' kg and how this ' + (family === 'tops' ? 'style' : family.replace('bottoms', 'cut').replace('dresses', 'dress').replace('outerwear', 'coat')) + ' is cut. Customers with similar measurements most often kept this size.';
      }
      $('[data-va-result]', modal).textContent = result ? String(result).replace(/\s*\(.*\)\s*/, '') : '?';
      $('[data-va-result]', modal).style.fontSize = result && String(result).length > 4 ? '28px' : '';
      $('[data-va-tags]', modal).innerHTML = tags.map(function (t) { return '<span>' + t + '</span>'; }).join('');
      $('[data-va-explain]', modal).textContent = explain;
      $('[data-va-add]', modal).style.display = result ? '' : 'none';
      $('[data-va-select]', modal).style.display = result ? '' : 'none';
    }

    function selectSize() {
      if (!result) return false;
      var sel = '.product-section input[type="radio"][data-index="option' + (optIndex + 1) + '"]';
      var input = $$(sel).filter(function (i) { return i.value === String(result); })[0];
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); var lab = document.querySelector('label[for="' + input.id + '"]'); if (lab) lab.click(); return true; }
      var dd = $$('.product-section select[data-index="option' + (optIndex + 1) + '"]')[0];
      if (dd) { dd.value = result; dd.dispatchEvent(new Event('change', { bubbles: true })); return true; }
      return false;
    }
    $('[data-va-select]', modal).addEventListener('click', function () { selectSize(); close(); });
    $('[data-va-add]', modal).addEventListener('click', function () {
      if (selectSize()) {
        close();
        setTimeout(function () { var b = $('.product-section [data-add-to-cart]'); if (b && !b.disabled) b.click(); }, 350);
      }
    });
  }

  /* ---------- Cart tier progress (2 → 10%, 3 → 15%, 4+ → 20%) ---------- */
  function tierUpdate(count) {
    var wrap = $('#va-tier'); if (!wrap) return;
    var fill = $('.va-tier__fill', wrap), msg = $('.va-tier__msg', wrap);
    fill.style.width = Math.min(count / 4 * 100, 100) + '%';
    $$('.va-tier__node', wrap).forEach(function (n) {
      var need = parseInt(n.dataset.need, 10);
      n.classList.toggle('is-on', count >= need);
      n.classList.remove('is-next');
    });
    var next = $$('.va-tier__node', wrap).filter(function (n) { return count < parseInt(n.dataset.need, 10); })[0];
    if (next) next.classList.add('is-next');
    var t;
    if (count <= 0) t = 'Add 2 items to save 10%';
    else if (count === 1) t = 'Add 1 more item and save 10%';
    else if (count === 2) t = '10% off unlocked · 1 more for 15%';
    else if (count === 3) t = '15% off unlocked · 1 more for 20%';
    else t = '20% off unlocked — our best bundle price';
    msg.textContent = t;
  }
  function tierFetch() { fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { tierUpdate(c.item_count); }).catch(function () {}); }
  function initTier() {
    var w = $('#va-tier'); if (!w) return;
    tierUpdate(parseInt(w.dataset.count, 10) || 0);
    document.addEventListener('cart:updated', function (e) { var c = e.detail && e.detail.cart ? e.detail.cart.item_count : null; c !== null ? tierUpdate(c) : tierFetch(); });
    document.addEventListener('ajaxProduct:added', function () { setTimeout(tierFetch, 300); });
    document.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('js-qty__num')) setTimeout(tierFetch, 600); });
    var products = $('#CartDrawer [data-products]');
    if (products && window.MutationObserver) { new MutationObserver(function () { clearTimeout(window.__vaT); window.__vaT = setTimeout(tierFetch, 250); }).observe(products, { childList: true, subtree: true }); }
  }


  /* ---------- Review rail progress + photo zoom ---------- */
  function initReviews() {
    $$('[data-va-rail]').forEach(function (rail) {
      if (rail.__va) return; rail.__va = 1;
      var wrap = rail.parentElement, bar = $('[data-va-rail-bar]', wrap), hint = $('.va-rail-hint', wrap);
      function upd() {
        if (!bar) return;
        var max = rail.scrollWidth - rail.clientWidth; var vis = rail.clientWidth / rail.scrollWidth;
        bar.style.width = Math.max(vis * 100, 12) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * ((1 / Math.max(vis, .12)) - 1) * 100 : 0) + '%)';
        if (hint && rail.scrollLeft > 20) hint.style.visibility = 'hidden';
      }
      rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
    var lb = $('[data-va-lightbox]');
    if (!lb || lb.__va) return; lb.__va = 1;
    var img = $('img', lb);
    function close() { lb.hidden = true; img.removeAttribute('src'); document.documentElement.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      var z = e.target.closest('[data-va-zoom]');
      if (z) { img.src = z.dataset.vaZoom; img.alt = (z.querySelector('img') || {}).alt || ''; lb.hidden = false; document.documentElement.style.overflow = 'hidden'; return; }
      if (!lb.hidden && (e.target === lb || e.target.closest('.va-lightbox__close'))) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
  }

  /* ---------- FAQ category tabs / jump links ---------- */
  function initFaq() {
    document.querySelectorAll('[data-va-faq="tabs"]').forEach(function (root) {
      if (root.__va) return; root.__va = 1;
      var tabs = root.querySelectorAll('[data-va-faq-tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var id = t.getAttribute('data-va-faq-tab');
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          root.querySelectorAll('[data-va-faq-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-va-faq-panel') !== id; });
          if (t.scrollIntoView && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        });
      });
    });
    document.querySelectorAll('[data-va-faq="list"] .va-faq__chip').forEach(function (a) {
      if (a.__va) return; a.__va = 1;
      a.addEventListener('click', function (e) {
        var el = document.querySelector(a.getAttribute('href')); if (!el) return;
        e.preventDefault();
        var y = el.getBoundingClientRect().top + window.pageYOffset - 130;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  function init() { initFaq(); initReviews(); initHero(); initCountdown(); initEta(); guardSamples(); initSizeAssistant(); initTier(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', function () { initFaq(); initReviews(); initHero(); initCountdown(); initEta(); });
})();
